import type { SVGProps } from "react";

/**
 * topaz
 * @category Social Media & Brands
 */
export default function IconTopaz(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 32 32' fill='none' aria-hidden {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M5.792 19.426v6.78h6.788v-6.78zm13.597 0v-6.781H12.6v6.78zm6.819-6.854v-6.78H19.42v6.78z'
        clipRule='evenodd'
      />
    </svg>
  );
}
